import { Button as Button, Dropdown as Dropdown, ScrollSpy as ScrollSpy, Tab as Tab, Collapse as Collapse } from 'bootstrap';
import '@fortawesome/fontawesome-free/css/all.css';
import Swiper, { Autoplay, Navigation, Pagination, Scrollbar, EffectFade, Mousewheel } from "swiper";
Swiper.use([Autoplay, Navigation, Pagination, Scrollbar, EffectFade, Mousewheel]);
import "swiper/swiper-bundle.css";

import InfiniteScroll from "infinite-scroll";

import Rellax from "rellax";

import AOS from "aos";
import "aos/dist/aos.css";


import './styles.scss';

document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
    if (window.scrollY > 100) {
      document.getElementById("header").classList.add("scrolled");
      document.getElementById("header").classList.remove("closed");
    } else {
      document.getElementById("header").classList.remove("scrolled");
      document.getElementById("header").classList.remove("closed");
    }
  });
});

const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--app-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", appHeight);
appHeight();

$( document ).ready( function() {

  $(".burger-button").on("click touch", function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $(".header-center").toggleClass("active");
  });

  $(".close-button").on("click touch", function (e) {
    e.preventDefault();
    $("header").removeClass("open");
    $(".burger .burger-button").removeClass("active");
    $(".header-right").removeClass("active");
  });

  if(window.location.hash) {
    var target = window.location.hash;
    $("html, body").animate({ scrollTop: $(target).offset().top - 90 }, 0);
  }

  $(function () {
    $('.current-menu-item a[href*="#"]:not([href="#"])').click(function () {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {

          $("header").removeClass("open");
          $('.burger-button').removeClass("active");
          $(".header-right").removeClass("active");

          $("html, body").animate(
            { scrollTop: $(target).offset().top - 90 },
            0
          );
          return false;
        }
      }
    });
  });


  $('.anchor').on('click touch', function (e) {
    e.preventDefault();
    var target = $(this).attr( 'href' );
    if ($(target).length > 0) {
      $("html, body").animate({ scrollTop: $(target).offset().top - 90 }, 0);
      return false;
    } else {
      $("html, body").animate({ scrollTop: $("#footer").offset().top - 90 }, 0);
      return false;
    }
  });

  if ($(".testimonials_block .quote").length > 1) {
    const swiperTestimonials = new Swiper(".testimonials_block .swiper", {
      pagination: {
        el: ".testimonials_block .swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      loop: true,
      slidesPerView: 1,
      spaceBetween: 30,
      autoplay: {
        delay: 5000,
      },
    });
  } else {
    $(".testimonials_block").addClass( "single-testimonial" );
  }

  if( $( window ).width() < 992 ) {
    /*
      $("header li.menu-item-has-children > a" ).on( 'click touch', function(e) {
        e.preventDefault();
        $( this ).parent( 'li' ).toggleClass( 'active' );
        $( this ).parent( 'li' ).find( '.sub-menu' ).slideToggle(300);
      });
    */
  }
  
  $(".popup-modal").magnificPopup({
    type: "inline",
    preloader: false,
    modal: false
  });
  $(document).on("click", ".close-popup", function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });


  if ($(".articles-list-container").length > 0) {
    var total = $("#post-list .article-container").length;

    let elem = document.querySelector(".articles-list-container");

    let infScroll = new InfiniteScroll(elem, {
      // options
      path: ".pagination a",
      append: ".article-container",
      history: false,
      loadOnScroll: false,
    });

    var $viewMoreButton = $(".pagination a");

    $viewMoreButton.on("click", function (e) {
      e.preventDefault();
      infScroll.loadNextPage();
    });

    infScroll.on("last", function (event, response, path) {
      $(".pagination").hide();
    });
  }


  $(".tab-button a").on( 'click touch', function(e) {
    e.preventDefault();
    $( this ).addClass( 'active' );
    var target = $( this ).attr( 'href' );
    $( '.tab-button a' ).not(this).removeClass( 'active' );
    if( !$( target ).hasClass( 'active' ) ) {
      $( '.tab-container' ).removeClass( 'active' ).hide();
      $( target ).addClass( 'active' ).fadeIn(1000);
      $("html, body").animate({ scrollTop: $(this).offset().top - 90 }, 500);
    }
  })


  $(".popup-video").magnificPopup({
    type: "iframe",
    mainClass: "mfp-fade",
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
  });


  var rellax = new Rellax(".rellax", {
    center: true
  });


  AOS.init({
    offset: 80, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 1000, // values from 0 to 3000, with step 50ms
    easing: "ease", // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
  });

});
